import {GET_VERIFICATION_DOCUMENT_LIST, GET_VERIFICATION_DOCUMENT_LIST_SUCCESS, GET_VERIFICATION_DOCUMENT_LIST_FAILED,
   GET_VERIFICATION_DOCUMENT_VIEW_DETAILS,GET_VERIFICATION_DOCUMENT_VIEW_DETAILS_SUCCESS,GET_VERIFICATION_DOCUMENT_VIEW_DETAILS_FAILED} from './actionType'



const initialState = {
   loading: false,
   documentlist: null ,
   errorMessage: null,
   viewDocData: null,
   
}

const verificationDocReducer = (state = initialState, action) => {

  switch (action.type) {
    case GET_VERIFICATION_DOCUMENT_LIST:
      state = {
        ...state,
        loading: true,
        documentlist: null ,
        errorMessage: null
      }
      break
    case GET_VERIFICATION_DOCUMENT_LIST_SUCCESS:
      state = {
        ...state,
        loading: false,
        documentlist: action.payload ,
        errorMessage: null
      }
      break
    case GET_VERIFICATION_DOCUMENT_LIST_FAILED:

      state = {
        ...state,
        loading: false,
        documentlist: null ,
        errorMessage: action.payload
      }
      break
      case GET_VERIFICATION_DOCUMENT_VIEW_DETAILS:
        state = {
          ...state,
          // loading: true,
          viewDocData: null
        }
        break
        case GET_VERIFICATION_DOCUMENT_VIEW_DETAILS_SUCCESS:
          state = {
            ...state,
            // loading: false,
          viewDocData: action.payload
          }
          break
          case GET_VERIFICATION_DOCUMENT_VIEW_DETAILS_FAILED:
            state = {
              ...state,
              // loading: false,
              viewDocData: null,
              errorMessage: action.payload
            }
            break
    default:
      state = { ...state }
      break
  }
  return state
}

export default verificationDocReducer
